export const SET_INITIALS_VALUE="SET_INITIALS_VALUE"
export const setInitialValues = (data) => {
    return {
        type: SET_INITIALS_VALUE,
        data
    }
}




/** WEBPACK FOOTER **
 ** ./src/store/actions/userFormInitialValuesAction.js
 **/